(function () {
  function initHeroSlideshow(root) {
    var slides = root.querySelectorAll('[data-hero-slide]');
    if (slides.length <= 1) return;

    var interval = parseInt(root.getAttribute('data-autoplay'), 10) || 4000;
    var current = 0;
    var timer = null;

    function show(index) {
      slides[current].classList.remove('is-active');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('is-active');
    }

    function start() {
      stop();
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      timer = window.setInterval(function () {
        show(current + 1);
      }, interval);
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    start();

    root.addEventListener('shopify:block:select', function (event) {
      var slide = event.target.closest('[data-hero-slide]');
      if (!slide) return;
      var index = Array.prototype.indexOf.call(slides, slide);
      stop();
      show(index);
    });

    root.addEventListener('shopify:block:deselect', start);
  }

  function initAll() {
    document.querySelectorAll('[data-hero-slideshow]').forEach(initHeroSlideshow);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-hero-slideshow]');
    if (root) initHeroSlideshow(root);
  });
})();
